import { Component } from '@angular/core';
import { AccessibilityService } from './accessibility-service.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  constructor(
    public accessibilityService: AccessibilityService
  ){}
}
